<div class="back-btn">
  <span class="material-icons">keyboard_arrow_left</span>
  <a routerLink="/login" class="back-btn">Return To Login</a>
</div>
<div class="login-container">
  <img class="login-logo" src="../../assets/img/logo.png" alt="logo" />
  <div class="title">Set Password</div>
  <hr />

  <div *ngIf="view === 'checking'" class="sm-text" role="status">
    Checking your link...
  </div>

  <div *ngIf="view === 'dead'" class="dead-link">
    <div class="sm-text dead-link-message">{{ token ? deadLinkMessage : missingLinkMessage }}</div>
    <button
      *ngIf="token"
      id="resend"
      type="button"
      class="btn btn-primary"
      (click)="resend()"
      [disabled]="isResending || !!resendMessage"
    >
      Email Me A New Link
    </button>
    <div *ngIf="resendMessage" class="sm-text resend-message mt-10" role="status">
      {{ resendMessage }}
    </div>
    <div class="sm-text mt-20">
      You can also request a new link from
      <a routerLink="/forgotpassword" class="login-links">Forgot Password</a>.
    </div>
  </div>

  <div *ngIf="view === 'unchecked'" class="unchecked-link">
    <div class="sm-text unchecked-link-message" role="alert">{{ uncheckedLinkMessage }}</div>
    <button id="retry-check" type="button" class="btn btn-primary" (click)="checkLink()">
      Try Again
    </button>
    <div class="sm-text mt-20">
      You can also request a new link from
      <a routerLink="/forgotpassword" class="login-links">Forgot Password</a>.
    </div>
  </div>

  <form
    *ngIf="view === 'form'"
    [formGroup]="setPasswordForm"
    (ngSubmit)="submit()"
  >
    <div class="create-form">
      <div class="form-control1">
        <label for="password" class="form-label"
          >New password <span class="req">*</span></label
        >
        <input
          id="password"
          [type]="showPassword ? 'text' : 'password'"
          class="input"
          formControlName="password"
          autocomplete="new-password"
          aria-describedby="password-rules"
          (blur)="trimPasswords()"
        />
        <button
          type="button"
          class="show-password"
          [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
          (click)="togglePasswordVisibility()"
        >
          <span class="material-icons" aria-hidden="true">{{
            !showPassword ? "visibility" : "visibility_off"
          }}</span>
        </button>
        <div id="password-rules" class="form-label">
          Password is case sensitive and must be 8 to 64 characters long.<br />
          At least 1 <b>lowercase</b> letter.<br />
          At least 1 <b>uppercase</b> letter.<br />
          At least 1 <b>numeric</b> character.<br />
          At least 1 <b>special</b> character.
        </div>
        <div
          *ngIf="
            setPasswordForm.controls.password.invalid &&
            (setPasswordForm.controls.password.dirty ||
              setPasswordForm.controls.password.touched)
          "
        >
          <div
            *ngIf="setPasswordForm.controls.password.errors?.['required']"
            class="error-message"
          >
            Password is required.
          </div>
          <div
            *ngIf="!setPasswordForm.controls.password.errors?.['required']"
            class="error-message"
          >
            Password does not meet the requirements.
          </div>
        </div>
      </div>
    </div>
    <div class="create-form mt-10">
      <div class="form-control1">
        <label for="confirmPassword" class="form-label"
          >Confirm password <span class="req">*</span></label
        >
        <input
          id="confirmPassword"
          [type]="showConfirmPassword ? 'text' : 'password'"
          class="input"
          formControlName="confirmPassword"
          autocomplete="new-password"
          (blur)="trimPasswords()"
        />
        <button
          type="button"
          class="show-password"
          [attr.aria-label]="
            showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'
          "
          (click)="toggleConfirmPasswordVisibility()"
        >
          <span class="material-icons" aria-hidden="true">{{
            !showConfirmPassword ? "visibility" : "visibility_off"
          }}</span>
        </button>
        <div
          *ngIf="
            setPasswordForm.controls.confirmPassword.errors?.['required'] &&
            (setPasswordForm.controls.confirmPassword.dirty ||
              setPasswordForm.controls.confirmPassword.touched)
          "
          class="error-message"
        >
          Please confirm your password
        </div>
        <div
          *ngIf="
            setPasswordForm.controls.confirmPassword.value !== '' &&
            setPasswordForm.errors?.['passwordMismatchError']
          "
          class="error-message"
        >
          Passwords do not match
        </div>
      </div>
    </div>
    <div *ngIf="serverMessage" class="error-message server-message" role="alert">
      {{ serverMessage }}
    </div>
    <hr />
    <div class="reset-password-helper-text">
      <span class="form-label"
        ><span class="req">*</span>Indicates a required field.</span
      >
    </div>
    <div class="panel-fields">
      <button type="submit" class="btn btn-primary" [disabled]="isSubmitting">
        Set Password
      </button>
    </div>
  </form>
</div>
